import type { SVGProps } from 'react';
const SvgGovernmentBuilding = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" viewBox="-0.5 -0.5 14 14" {...props}>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6.469 4.7a.232.232 0 0 1 0-.464M6.469 4.7a.232.232 0 0 0 0-.464" />
      <path d="M3.969 3.135v9.168h5V3.135L6.468.634zM.635 5.231a.93.93 0 0 1 .929-.929h2.405v8.001H.635zM8.969 4.302h2.405a.93.93 0 0 1 .929.929v7.072H8.97V4.302Z" />
      <path d="M5.518 10.442a.98.98 0 0 1 .981-.981v0a.98.98 0 0 1 .981.981v1.861H5.518zM.635 7.756h11.668M2.302 9.809v.667M10.636 9.809v.667" />
    </g>
  </svg>
);
export default SvgGovernmentBuilding;
